import colors from "core/resources/theme/colors";
import styled from "styled-components";

export const Container = styled.div`
  .ant-tree-select {
    .ant-select-selector {
      .ant-select-selection-item,
      .ant-select-selection-placeholder {
        font-size: 12px !important;
        color: ${colors.black900} !important;
      }
    }
  }
`;
